__turbopack_context__.v({
  "boostedText": "styles-module__JXxf5G__boostedText",
  "image": "styles-module__JXxf5G__image",
  "imageOverlay": "styles-module__JXxf5G__imageOverlay",
  "imageWrapper": "styles-module__JXxf5G__imageWrapper",
  "interactiveImageWrapper": "styles-module__JXxf5G__interactiveImageWrapper",
  "likesNumber": "styles-module__JXxf5G__likesNumber",
  "likesWrapper": "styles-module__JXxf5G__likesWrapper",
  "soldText": "styles-module__JXxf5G__soldText",
});
